/* eslint-disable react/no-danger */
/* eslint-disable max-len */
import DefaultAvatar from 'Assets/images/pages/web-chat/avatar-default.png';
import { CONSULT_ACCEPTED, CONSULT_PENDING } from 'Constants/consults';
import useConsult from 'Containers/Teleconsult/hooks/useConsult';
import { formatDate, generateIncludeParams } from 'Helpers/utils';
import useMcHistory from 'Hooks/useMcHistory';
import { upperFirst } from 'lodash';
import Space from 'Modules/Space';
import moment from 'moment';
import { shape } from 'prop-types';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { consultDetails } from 'Redux/modules/webChat/actions';
import { openGallery } from 'Redux/modules/webChat/allMedia/actions';
import { Dimmer, Loader } from 'semantic-ui-react';
import PrivateImage from 'Modules/PrivateImage/PrivateImage';
// import ReactCountryFlag from 'react-country-flag';

import styles from './RequestContent.less';

const consultDetailsResponseParams = {
  include: generateIncludeParams({
    id: true,
    for_patient: true,
    patient: true,
    source_name: true,
    reason: true,
    files: true,
    medical_conditions: true,
    drug_allergies: true,
    status: true,
    service: true,
    extra_data: true,
    // Don't ask me why:)
  }).replaceAll(',pool', ''),
};

const RequestContent = props => {
  // const [location, setLocation] = useState(); // NOSONAR

  const { getCountHistoryMc } = useMcHistory();
  const { message } = props;

  const {
    createdAt,
    metadata: { conversationId, consultId },
  } = message;

  const consult = useConsult(consultId);

  const isPendingOrAccepted =
    consult?.status === CONSULT_PENDING || consult?.status === CONSULT_ACCEPTED;
  const {
    forPatient: { fullName, genderAtBirth, nric, dateOfBirth, avatarUrl, id, firstName, lastName },
    patient,
    reason,
    files,
    drugAllergies,
    medicalConditions,
  } = consult ?? {
    forPatient: { fullName: '', firstName: '', lastName: '' },
  };

  const service = consult?.service;
  const { name: serviceName } = service ?? {};

  const description = `${
    genderAtBirth ? `${upperFirst(genderAtBirth)},` : ''
  } ${nric}, ${formatDate(dateOfBirth)}`;

  const requestedBy = `${patient?.fullName} (${
    patient?.genderAtBirth ? `${upperFirst(genderAtBirth)},` : ''
  } ${patient?.nric}, ${patient?.dateOfBirth ? formatDate(patient?.dateOfBirth) : ''})`;

  const dispatch = useDispatch();
  const handleClickImage = useCallback(
    (fileImage, media = []) => {
      dispatch(openGallery(conversationId, fileImage, media));
    },
    [dispatch, conversationId],
  );

  const bookedForName = fullName || `${firstName || ''} ${lastName || ''}`;

  useEffect(() => {
    const fetchData = async () => {
      const consultDetail = await dispatch(consultDetails(consultId, consultDetailsResponseParams)); // NOSONAR
      // if (consultDetail?.data && isPendingOrAccepted) {
      // const { extraData } = consultDetail?.data ?? {};
      // if (extraData) setLocation(extraData?.geoLocation);
      // }
    };
    fetchData();
  }, [consultId, dispatch, getCountHistoryMc, isPendingOrAccepted]);

  return (
    <div>
      <Dimmer active={!consult} inverted>
        <Loader />
      </Dimmer>
      {consult && (
        <>
          <Space direction="horizontal" alignItems="start" size={8} className={styles.bookedFor}>
            <img className={styles.avatar} src={avatarUrl ?? DefaultAvatar} alt="" />
            <Space direction="vertical" alignItems="start" size={0}>
              <div>Booked for</div>
              <h3>{bookedForName}</h3>
              <p>{description}</p>
            </Space>
          </Space>

          {patient.id !== id && (
            <div className={styles.item}>
              <div className={styles.title}>Requested by</div>
              <div className={styles.description}>{requestedBy}</div>
            </div>
          )}
          <div className={styles.item}>
            <div className={styles.title}>
              {consult?.status === CONSULT_PENDING ? 'Requested time' : 'Consult time'}
            </div>
            <div className={styles.description}>
              {moment.utc(createdAt).local().format('MMM D, YYYY HH:mm')}
            </div>
          </div>
          {serviceName && (
            <div className={styles.item}>
              <div className={styles.title}>Initiated from</div>
              <div className={styles.description}>{serviceName}</div>
            </div>
          )}
          {reason && (
            <div className={styles.item}>
              <div className={styles.title}>Reason for consultation</div>
              <div className={styles.description}>{reason}</div>
              {files?.length > 0 && (
                <div className={styles.images}>
                  {files.map(i => (
                    <div
                      key={i.id}
                      className={styles.image}
                      onClick={() => handleClickImage(i, files)}>
                      <PrivateImage
                        style={{ maxHeight: '100%', maxWidth: '100%' }}
                        type="thumbnail"
                        src={i.thumbPath}
                        alt=""
                      />
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          <div className={styles.item}>
            <div className={styles.title}>Pre-existing medical condition</div>
            <div className={styles.description}>{medicalConditions || 'N/A'}</div>
          </div>
          <div className={styles.item}>
            <div className={styles.title}>Drug allergies</div>
            <div className={styles.description}>{drugAllergies || 'N/A'}</div>
          </div>
        </>
      )}
    </div>
  );
};

RequestContent.defaultProps = {};
RequestContent.propTypes = {
  message: shape({}).isRequired,
};

export default RequestContent;
